// extracted by mini-css-extract-plugin
var _1 = "heliogramgraph_figure";
var _2 = "heliogramgraph_svg";
export { _1 as "figure", _2 as "svg" }
